import React from 'react';

import {Icons, Sizes} from '@pb/kit-component-icon';
import IconButton from '@pb/kit-component-icon-button';

import {removeButton, removeButtonDisabled} from './remove-button.module.styl';

type Props = {
    disabled?: boolean,
    onRemove: () => void,
};
export const RemoveButton = ({disabled, onRemove}: Props) => (
    <IconButton
        disabled={disabled}
        className={`${removeButton} ${disabled ? removeButtonDisabled : ''}`}
        onClick={onRemove}
        iconProps={{type: Icons.CLOSE, size: Sizes.Size_19}}
    />
);
